import {
  Component,
  OnInit,
  inject,
  input,
  output,
  signal,
  model,
  viewChild,
} from '@angular/core';
import {
  NgbCalendar,
  NgbDate,
  NgbDatepicker,
  NgbDatepickerI18n,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  I18n,
  CustomFlightDatepickerI18n,
} from '../../services/app/ngb-datepicker-i18n.service';
import { LunarDayPipe } from '../../pipes';
import { LunarDateService } from '../../services/app';

@Component({
  selector: 'app-lunar-datepicker',
  templateUrl: './lunar-datepicker.component.html',
  standalone: true,
  imports: [NgbDatepickerModule, LunarDayPipe],
  providers: [
    LunarDateService,
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomFlightDatepickerI18n },
  ],
})
export class LunarDatepickerComponent implements OnInit {
  private calendar = inject(NgbCalendar);
  private dp = viewChild<NgbDatepicker>('dp');
  useRange = input(false);
  displayMonth = input(1);
  selected = output<NgbDate[]>();

  hoveredDate = signal<NgbDate | null>(null);
  fromDate = model<NgbDate | null>(null);
  toDate = model<NgbDate | null>(null);
  minDate = model<NgbDate | null>(null);
  maxDate = model<NgbDate | null>(null);

  ngOnInit(): void {
    if (this.fromDate()) {
      this.dp()?.navigateTo(this.fromDate()!);
    }

    this.minDate.set(this.calendar.getToday());
    this.maxDate.set(new NgbDate(this.calendar.getToday().year + 1, 12, 31));

    if (this.useRange()) {
      !this.fromDate() &&
        this.toDate.set(
          this.calendar.getNext(this.calendar.getToday(), 'd', 10),
        );
    } else {
      this.toDate.set(this.fromDate());
    }
  }

  onDateSelection(date: NgbDate) {
    if (this.useRange()) {
      if (!this.fromDate() && !this.toDate()) {
        this.fromDate.set(date);
      } else if (
        this.fromDate() &&
        !this.toDate() &&
        date.after(this.fromDate())
      ) {
        this.toDate.set(date);
        this.selected.emit([this.fromDate()!, this.toDate()!]);
      } else {
        this.toDate.set(null);
        this.fromDate.set(date);
      }
    } else {
      this.fromDate.set(date);
      this.toDate.set(this.fromDate());
      this.selected.emit([this.fromDate()!, this.toDate()!]);
    }
  }

  isToday(date: NgbDate) {
    const today = this.calendar.getToday();
    return (
      date.year === today.year &&
      date.month === today.month &&
      date.day === today.day
    );
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate() &&
      !this.toDate() &&
      this.hoveredDate() &&
      date.after(this.fromDate()) &&
      date.before(this.hoveredDate())
    );
  }

  isInside(date: NgbDate) {
    return (
      this.toDate && date.after(this.fromDate()) && date.before(this.toDate())
    );
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate()) ||
      (this.toDate && date.equals(this.toDate())) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  isOutside(date: NgbDate, currentMonth: number) {
    return date.month !== currentMonth;
  }
}
